var _defs, _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#013177;}.cls-2{fill:#fff;}.cls-3{fill:#33c3ef;}.cls-4{fill:#00a4e3;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.5,
    cy: 61.5,
    r: 39
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 61.5,
    cy: 61.5,
    r: 33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.63,48a19.54,19.54,0,0,1,8.5,2l1.72-6.68a21.27,21.27,0,0,0-8.57-1.94v-5.2H59.49v5.61c-6.32,1.24-10,5.31-10,10.51,0,5.73,4.31,8.69,10.63,10.81.6.2,1.16.41,1.67.61l5-6.9-1.2-.44c-5-1.89-7.08-3.13-7.08-5.08C58.55,49.62,59.79,48,63.63,48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.5,67.4c0,5.26-3.72,9.75-10.51,10.93v6H59.2V78.74a23.61,23.61,0,0,1-10-2.54l1.77-6.91a20.84,20.84,0,0,0,9.8,2.6c3.37,0,5.68-1.3,5.68-3.66,0-1.93-1.41-3.25-4.6-4.53l5-6.9C73,59.23,75.5,62.4,75.5,67.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco3);
export default __webpack_public_path__ + "static/media/ico-3.7e347980f3bbace87dbb7966a8cfb47e.svg";
export { ForwardRef as ReactComponent };